import { BookingType, CustomerTypes, SEARCH_FIELDS } from "app/app.types";
import { BookingMethods, paymentProviderTypeUppercase } from "shared-types";
import ObjectCopyService from "external-services/object-copy-service/index";
import BeverageHistoryService from "app/services/beverageHistory/BeverageHistory.service";
import { CustomerGeneratorService } from "external-services/customer-generator-service";
import CustomerValidationService from "app/services/customerValidation/customerValidation.service";
import CustomerSearchService from "external-services/customer-search-service";
import AdminService from "external-services/diary-admin-service/admin.service";
import PhoneNumberService from 'external-services/phone-number-service/index';
import { phoneNumberTypes } from 'external-services/phone-number-service/phoneNumber.types';
import CustomerLookupService from 'external-services/customer-lookup-service';
import { cloneDeep, debounce, isEmpty } from 'lodash-es';
import TagsService from "external-services/tags-service";
import { customerViewType } from './types';
import { LocaleService } from 'app/services/locale/locale.service';
import ViewActionsService from 'app/actions/view.actions';
import NetworkConnectionService from 'external-services/network-connection-service';
import BookingsUtilsService from 'app/services/bookingsUtils/bookingsUtils.service';
import { MessageService } from 'external-services/message-service/index';

// requiring html templates so that hot reloading works
const template = require('./customerDetails.html');

/**
 * These html paths are needed for the webpack build, so they can be added to the template cache
 */
//templateUrl="app/customers/customerDetails/oldCustomerDetailsForm.html"
//templateUrl="app/customers/customerDetails/standardCustomerDetailsForm.html"

const NS = 'CustomerDetails'; // jshint ignore:line

export default function CustomerDetails() {
  return {
    bindToController: true,
    template,
    controllerAs: 'vm',
    restrict: 'E',
    scope: {
      selectedTab: '=',
      bookingMethod: '=',
      customer: '=',
      isBookedBy: '=',
      bookedByCustomerDetails: '=',
      setBookedByCustomerDetails: '=',
      displayErrors: '=',
      emailRequired: '<',
      customerValid: '=?',
      isEditCustomer: '=?',
      editOnly: '=',
      bookingType: '=',
      beverageList: '<',
      currency: '<',
      isNewBookingBeingCreated: '<',
      openRepeatBookingTab: "=?",
      shouldShowRepeatBookingIcon: '=',
      handleOriginalCustomerChange: '=?',
      isNoPayment: '=?',
      isRecurringBooking: '=?',
      disableEmailSmsNotification: '=?',
      isDuplicatedCustomer: '=',  // indicate if customer is duplicated, newBookingController page
      switchCustomerView: '=', // to switch customer view, newBookingController page
      customerSearchResult: '=',
      handleNewCustomerSelected: '=', // to handle new customer selected, newBookingController page
      isUsingExistingCustomerSearch: '=?',
      setSkipCustomerDuplicationCheck: '=', // to skip customer duplication check, newBookingController page
      setHiddenDialog: '=', // to hidden parent dialog, newBookingController page
      cleanBookedByData: '=', // to clean bookedBy data(bookedBy toggle off || change new customer form view: search/display/new), newBookingController page
      isPrivateFunEvent: '=?', // to indicate if it is private fun event
      skipAutoComplete: '=?',
    },
    controller
  };
}


// just exported for unit tests
export function controller($scope, $q, $mdDialog, $timeout, $rootScope, unregister) {
  "ngInject";

  const vm = this;
  let updatingCustomer = false;
  let lastQuery = '';
  var orgBooking = BookingsUtilsService.getEditBookingOriginal();

  vm.editBookingMode = !!orgBooking;
  vm.standardCustomerDetailsFormTemplate = 'app/customers/customerDetails/standardCustomerDetailsForm.html';
  vm.oldCustomerDetailsFormTemplate = 'app/customers/customerDetails/oldCustomerDetailsForm.html';
  vm.customerViewType = customerViewType;
  vm.SEARCH_FIELDS = SEARCH_FIELDS;
  vm.autoCompleteDelay = 1500;
  vm.CustomerTypes = CustomerTypes;
  vm.PHONE_VALIDATION_MESSAGE_ON_NON_PHONE_FIELD = 'You are searching on phone number, please enter 6 or more digits';
  vm.PHONE_VALIDATION_MESSAGE = 'Please enter 6 or more digits';
  vm.hideProgress = {
    // contains dynamic properties of SEARCH_FIELDS names
  };
  vm.phoneNumberTooShort = {
    // contains dynamic properties of SEARCH_FIELDS names
  };

  vm.bookedByErrors = {}
  vm.setBookedByErrors = setBookedByErrors

  vm.hideStopNotification = false;
  vm.BOOKING = BookingType.Booking;
  vm.SBL = BookingType.StandbyList;
  vm.WL = BookingType.WaitList
  vm.phoneValidationMessage = '';
  vm.toggleEmailSmsNotification = toggleEmailSmsNotification
  vm.venue = AdminService.getVenue();
  vm.sblEmailRequired = vm.venue.standByListEmail;
  vm.sblSmsRequired = vm.venue.standByListSMS;
  vm.birthdayContainerClass = !!orgBooking
    ? 'birthday-container-with-communication-column'
    : 'birthday-container-with-communication-column'
  const isSmsEnabled = vm.venue.smsEnabled;
  vm.smsEmailMessage = `${isSmsEnabled ? 'Do not send emails or SMS' : 'Do not send emails'}`;

  //-- define public properties
  // Allow customer select with no value lead to empty attribute in binding customer (lead to an angular exception)
  vm.minQueryToSearch = 2; // note: this is not used for "customer", which is hardcoded in HTML
  vm.maxPhoneLength = 25;
  vm.days = [];
  for (var i = 1; i < 32; i++) {
    vm.days.push(i);
  }

  vm.months = [];
  for (var j = 1; j < 13; j++) {
    vm.months.push(j);
  }

   // CSS flex order for birthday fields — locale-aware via LocaleService
  vm.birthdayFieldOrder = LocaleService.getDateFieldOrder();

  vm.isPhoneValid = true;
  vm.isPhoneBookedByCustomerValid = true

  //-- define public methods
  vm.search = search;
  vm.customerSearch = customerSearch;

  vm.customerSelected = customerSelected;
  vm.isCustomerSelected = false;
  vm.clearEdit = clearEdit;
  vm.newCustomer = newCustomer;
  vm.country = vm.venue.country;
  vm.originCustomer = null;
  vm.isPhoneNumberType = true; // phone picker flag can use?
  vm.handlePhoneChange = handlePhoneChange;
  vm.phoneWithoutPrefix = '';
  vm.phoneInitial = '';
  vm.searchByEmail = searchByEmail;
  vm.setPhoneValid = setPhoneValid;
  vm.setPhoneTouched = setPhoneTouched;
  vm.setPhoneWithoutPrefix = setPhoneWithoutPrefix;

  // Following NBI-6152 and NBI-6309
  if (!isEmpty(vm.venue.titleSubscription)) {
    vm.titleSubscription = MessageService.getMessage(
      vm.venue.titleSubscription,
      { venueName: vm.venue.name },
      null
    )
  }

  vm.emailValidation = emailValidation; //(...args) => CustomerValidationService.emailValidation(...args);
  vm.getValidationError = getValidationError;

  vm.showBeverageHistoryPage = false;
  vm.beverageCloseButtonText = "Close";
  vm.beverageDialogHeader = "Beverages";
  vm.shouldShowBeverageIcon = shouldShowBeverageIcon;
  vm.openBeverageHistoryPage = openBeverageHistoryPage;
  vm.toggleBeverageHistoryPage = toggleBeverageHistoryPage;
  vm.switchToRepeatBookingTab = switchToRepeatBookingTab;
  vm.initialCheck = true;
  vm.isPhoneDirty = false;
  vm.viewType = vm.customerViewType.SEARCH_CUSTOMER_VIEW;
  vm.customers = [];
  vm.setCustomerSearch = setCustomerSearch;
  vm.setView = setView;
  vm.setCustomers = setCustomers;
  vm.searchInNewCustomerForm = searchInNewCustomerForm;
  vm.handleDisplayCustomer = handleDisplayCustomer;
  vm.handleEditCustomer = handleEditCustomer;
  vm.customerSearchObj = {};
  vm.errors = {};
  vm.expandedCustomer = true;
  vm.expandBookedBy = false;
  vm.setErrors = setErrors;
  vm.bookedByEnabled = false;
  vm.toggleBookedBy = toggleBookedBy;
  vm.toggleBookedByNoEvent = toggleBookedByNoEvent;
  vm.triggerBookedByValidation = 0;
  vm.skipFirstRender = false;
  vm.searchResultStatus = 0;
  vm.showMore = false;
  vm.handleShowMore = handleShowMore;
  vm.isEwayAndNotWalkinBooking = false;
  vm.firstNameTitle = 'Name';
  vm.firstNameRequiredText = 'A first or surname is required';
  vm.lastNameRequiredText = 'A first or surname is required';
  vm.inputContainerClass = '';
  vm.subscribed = vm.venue.defaultEmailSubscribedForDiary;

  var listeners = [];
  if (window.config.phoneValidation) {
    listeners.push($scope.$watch('vm.customer.phone', phoneChange));
  }
  listeners.push($scope.$on('$destroy', () => unregister(listeners)));
  vm.inputOnFocus = inputOnFocus;
  addListeners();

  vm.$onInit = () => {
    vm.subscribed = vm.customer?.subscribed || vm.venue.defaultEmailSubscribedForDiary;
    vm.phoneWithoutPrefix = vm.customer?.phone || '';
    vm.phoneInitial = vm.customer?.phone || '';
    TagsService.getTags().then(function (tags) {
      vm.allTags = tags;
    });
    updateEmailRequired();
    checkIsPhoneNumberType();
  };

  function addListeners() {
    listeners.push($scope.$watch('vm.selectedTab', watchTabSelected));
    listeners.push($scope.$watch('vm.customer.birthdayDate', validateCustomer));
    listeners.push($scope.$watch('vm.customer.birthdayMonth', validateCustomer));
    listeners.push($scope.$watch('vm.customer.birthdayYear', validateCustomer));
    listeners.push($scope.$watch('vm.customer.lastName', () => {
      validateCustomer();
      updateComponentText();
    }));
    listeners.push($scope.$watch('vm.customer.firstName', () => {
      validateCustomer();
      updateComponentText();
    }));
    listeners.push($scope.$watch('vm.customer.phone', validateCustomer));
    listeners.push($scope.$watch('vm.customer.email', validateCustomer));
    listeners.push($scope.$watch('vm.bookedByErrors', validateCustomer));

    listeners.push($scope.$watch('vm.isRecurringBooking', validateCustomer));
    listeners.push($scope.$watch('vm.isNoPayment', () => {
      validateCustomer();
      updateComponentText();
    }));
    listeners.push($scope.$watch('vm.isPhoneValid', ((newVal, oldVal) => {
      // setIsPhoneValid was getting triggered after validateCustomer for selected customers
      if (vm.isPhoneValid) {
        validateCustomer();
      }
    })));
    listeners.push($scope.$watch('vm.bookingType', () => {
      updateEmailRequired();
      updateComponentText();
    }));
    listeners.push($scope.$watch('vm.switchCustomerView', updateCustomerFormView));
    listeners.push($scope.$watch('vm.bookedByErrors', validateCustomer));
    listeners.push($scope.$watch('vm.subscribed', ((newVal, oldVal) => {
      if (!vm.customer._id) {
        vm.customer?.subscribed = newVal
      }
    })));
    listeners.push($scope.$watch('vm.customerSearchResult', (newValue) => setCustomers(newValue)));
  }
  function watchTabSelected(newVal, oldVal) {
    // Only show NEW_CUSTOMER_VIEW if there is no id from customer
    if (oldVal === 1 && newVal !== 1 && vm.customerValid && !vm.customer._id) {
      setView(vm.customerViewType.NEW_CUSTOMER_VIEW, false);
    }
  }

  // this is for switch view when user click save button
  function updateCustomerFormView() {
    if (!vm.skipFirstRender) {
      vm.skipFirstRender = true;
    } else {
      vm.triggerBookedByValidation += 1;
    }
    // check duplication, should jump to search view
    if (vm.isDuplicatedCustomer) {
      if (vm.viewType !== vm.customerViewType.SEARCH_CUSTOMER_VIEW) {
        vm.viewType = vm.customerViewType.SEARCH_CUSTOMER_VIEW;
      }
      vm.customerSearchObj = {
        ...vm.customer
      }
    }
    // check customer not valid, should jump to new customer view if the error not from display page,
    // otherwise, should jump to display page
    if (!vm.customerValid && Object.keys(vm.customerSearchObj).length > 0 && vm.viewType === vm.customerViewType.SEARCH_CUSTOMER_VIEW) {
      vm.viewType = vm.customerViewType.NEW_CUSTOMER_VIEW;
      vm.customer = {
        ...vm.customerSearchObj,
      };
      vm.phoneInitial = vm.customer.phone || '';
      if (vm.customer.phone) {
        if (CustomerGeneratorService.isPhoneNumberTooShortForSearch(vm.customerSearchObj.phone)) {
          vm.phoneNumberTooShort[SEARCH_FIELDS.PHONE] = true;
        } else {
          const res = PhoneNumberService.parsePhoneNumber(vm.customer.phone);
          vm.isPhoneValid = res.isValid();
        }
        vm.isPhoneTouched = true;
      }
    }
    // expand form if not valid
    if (vm.viewType === vm.customerViewType.NEW_CUSTOMER_VIEW) {
      // expand customer section if not valid
      if (!vm.customerSectionValid) {
        vm.expandedCustomer = true;
      }
    }
    if (vm.viewType !== vm.customerViewType.SEARCH_CUSTOMER_VIEW) {
      // expand booked by section if not valid
      if (!vm.bookedBySectionValid && vm.isBookedBy) {
        vm.expandBookedBy = true;
      }
    }
  }
  // to record last focus input
  function inputOnFocus(name) {
    vm.inputFocused = name;
  }
  function shouldShowBeverageIcon() {
    // Hiding wine button again as part of https://nowbookit.atlassian.net/browse/NBI-4608

    // if (!vm.isNewBookingBeingCreated) {
    //   return false;
    // }
    //
    // return !isEmpty(vm.beverageList);
    return false;

  }

  function checkMdAutoCompleteMaxLength() {
    setTimeout(() => {
      if (!vm.customer.phone || vm.customer.phone.length <= 25) { // if existing customer's phone length is less than 25, set max length as 25, This is so we do not remove potentially important data that might already be saved there.
        let phoneInputElement = document.querySelector('[id="phone-input-field-selector-id"]');
        console.log('phoneInputElement', phoneInputElement)
        if (phoneInputElement) phoneInputElement.setAttribute('maxLength', 25);
      }
    }, 1000);
  }

  function checkIsPhoneNumberType() {
    var checkPhone = vm.customer?.phone;
    vm.isPhoneNumberType = CustomerValidationService.checkIsPhoneNumberType(checkPhone);

    if (!vm.isPhoneNumberType) checkMdAutoCompleteMaxLength();
  }

  function openBeverageHistoryPage() {
    // Fetch <<BeverageHistoryPage /> to pass as a child to <AlertDialog />
    vm.getBeverageHistoryPage = BeverageHistoryService.getBeverageHistoryPageComponent(vm.beverageList, vm.currency);
    toggleBeverageHistoryPage();
  }

  /** Show/Hide the beverage history page */
  function toggleBeverageHistoryPage() {
    vm.showBeverageHistoryPage = !vm.showBeverageHistoryPage;
  }

  // moved to CustomerValidationService.checkRulesByBookingTypeAndCustomerType
  function updateEmailRequired() {
    switch (vm.bookingType) {
      case BookingType.StandbyList:
        vm.emailRequired = vm.sblEmailRequired;
        vm.ignorePhoneValidation = !vm.sblSmsRequired;
        vm.hideStopNotification = true;
        vm.disableEmailSmsNotification = false;
        break;

      case BookingType.WaitList:
        vm.emailRequired = false;
        vm.ignorePhoneValidation = true;
        vm.hideStopNotification = true;
        vm.disableEmailSmsNotification = false;
        break;

      default:
        if (vm.customer && vm.customer.customerType === CustomerTypes.inline) {
          vm.emailRequired = false;
          vm.ignorePhoneValidation = true;
          vm.hideStopNotification = true;
          vm.disableEmailSmsNotification = false;
        } else {
          vm.emailRequired = $scope.emailRequired || false;
          vm.ignorePhoneValidation = false;
          vm.hideStopNotification = false;
        }
    }
  }

  function updateComponentText() {
    const isWalkIn = vm.bookingMethod === BookingMethods.walkin;
    const venueHasEwayPayment = vm.venue.paymentSettings?.paymentProvider === paymentProviderTypeUppercase.Eway;
    const bookingGotNoPayment = vm.isNoPayment;

    // Case 1
    // BookingMethod is walkin
    if (isWalkIn) {
      vm.firstNameTitle = "Name";
      vm.firstNameRequiredText = "A Name is required";
      vm.isEwayAndNotWalkinBooking = false;
      vm.inputContainerClass = ''
    }

    // Case 2
    // Normal booking and venue has eway payment and booking has payment
    // Result
    // Make first name and surname required
    if (!isWalkIn && venueHasEwayPayment && !bookingGotNoPayment) {
      vm.inputContainerClass = 'customer-form-wrapper';
      vm.isEwayAndNotWalkinBooking = true;
      vm.firstNameTitle = "First name";
      vm.firstNameRequiredText = "A first name is required";
      vm.lastNameRequiredText = "A surname is required";
    }

    // Case 3
    // Normal booking and venue has eway payment and booking does not have payment
    // Or Normal booking and venue does not have eway payment
    // Result
    // Either first name or surname should be required
    if (
      (!isWalkIn && venueHasEwayPayment && bookingGotNoPayment)
      || (!isWalkIn && !venueHasEwayPayment)
    ) {
      vm.inputContainerClass = 'customer-form-wrapper';
      vm.isEwayAndNotWalkinBooking = false;
      vm.firstNameTitle = "First name";
      vm.firstNameRequiredText = "A first or surname is required";
      vm.lastNameRequiredText = "A first or surname is required";
    }
  }

  function customerSearch(phoneStr, countryStr = null) {
    return vm.search(phoneStr, vm.SEARCH_FIELDS.PHONE, countryStr);
  }
  // todo we need separate search and validation in future when we rewrite customer form in react.
  /** Load customers matching the search criteria */
  function search(query, field, countryStr = null, customerObj = null) {
    const searchObject = customerObj || vm.customer;
    if (field !== vm.inputFocused && field !== vm.SEARCH_FIELDS.PHONE) {
      return Promise.resolve([]);
    }
    vm.hideProgress[field] = false;
    vm.phoneNumberTooShort[field] = false;

    if (!vm.editOnly) {
      return $q((resolve, reject) => {
        if (!updatingCustomer) {

          // May need this in future when restricting name field entry
          // if (field === SEARCH_FIELDS.FIRST_NAME || field === SEARCH_FIELDS.LAST_NAME) {
          //   query = CustomerGeneratorService.restrictNameFields(query, field, vm.customer);
          //   if (!query) {
          //     return;
          //   }
          // }

          if (field === SEARCH_FIELDS.EMAIL) {
            if (!CustomerGeneratorService.minimumEmail(query)) {
              vm.hideProgress[field] = true;
              return;
            }
          } else if (field === SEARCH_FIELDS.COMPANY) {
            /**
             * company field should no have any validation because it can sometimes get used with membership numbers
             * that may look like phone numbers, but are not
             */
          } else if (field === SEARCH_FIELDS.PHONE) {

            // for all other fields we need to detect if they are trying to enter a phone number and validate they have 6 numbers
            if (CustomerGeneratorService.isPhoneNumberTooShortForSearch(query)) {
              vm.hideProgress[field] = true;
              vm.phoneNumberTooShort[field] = true;
              return;
            }
            validateCustomer()
            // this condition to trigger data validation for phone number but no search for new form
            if (vm.customer.customerType !== vm.CustomerTypes.inline && vm.viewType === vm.customerViewType.NEW_CUSTOMER_VIEW) {
              return;
            }
          }
          vm.lastQuery = query;
          const customerSearchArray = CustomerValidationService.getCustomerValue(searchObject);
          if (customerSearchArray.length === 0) {
            vm.hideProgress[field] = true;
            return;
          }
          const searchOptions = {
            count: 15,
            searchFields: customerSearchArray,
          };
          // for new customer form search, we need to pass venueId to get permanent tags
          // we also need pass page and amount when we do pagination.
          searchOptions.options = {
            venueId: vm.venue.id,
          };
          CustomerSearchService.specificSearch(searchOptions, true).then(result => {
            resolve(result.items.map(customer => {
              customer.label = CustomerGeneratorService.getDisplayName(customer, true);
              return customer;
            }));
          }).catch(error => reject(error));
        } else {
          resolve([]);
        }
      });
    } else {
      return Promise.resolve([]);
    }
  }

  function searchByEmail() {
    return vm.search(vm.customer.email, vm.SEARCH_FIELDS.EMAIL);
  }

  function toVenueCustomer(accountCustomer, venueId) {
    if (!accountCustomer)
      return accountCustomer;
    const venue = accountCustomer.customerVenueDetails.find(venue => venue.venueId === venueId);
    const venueCustomer = cloneDeep(accountCustomer);
    const sharedTagIdentifiers = accountCustomer.customerSharedTags.map(tag => tag.identifier);
    venueCustomer.tags = vm.venue.tags && vm.venue.tags.filter(tag => sharedTagIdentifiers.includes(tag._id));
    if (venue && venue.tags && venue.tags.length > 0 && vm.allTags) {
      let diaryTags = vm.allTags.filter(tag => venue.tags.includes(tag.name));
      venueCustomer.tags.push(...diaryTags);
    }
    venueCustomer.venueIds = venueCustomer.customerVenueDetails.map(venue => venue.venueId);
    venueCustomer.hasVisitedMultipleVenues = venueCustomer.venueIds.length > 1;
    venueCustomer.subscribed = !!(venue?.subscribed);
    venueCustomer.managerNotes = venue?.managerNotes || '';
    venueCustomer.noShowCount = venue?.noShowCount || 0;
    venueCustomer.membershipNumber = venue?.membershipNumber || '';

    delete venueCustomer.customerVenueDetails;
    delete venueCustomer.customerSharedTags;
    return venueCustomer;
  }

  /**
   * A customer has been selected out of the search
   * // Customers searched are from account level, they don't have venue informations
   // like subscribed, tags, managerNotes
   // I look up for the venue level entity and use it, fallback to the account one if missing
   * @param  {object} customerItem
   */
  function customerSelected(customerItem) {
    if (customerItem) {
      if (customerItem._id) {
        vm.isCustomerSelected = true
        $q(resolve => {
          CustomerLookupService.getAccountCustomerById(customerItem._id).then(accountCustomer => {
            const venueCustomer = toVenueCustomer(accountCustomer, vm.venue.id);
            if (venueCustomer) {
              console.log('Replace customer with its more detailed venue entity');
              customerItem = venueCustomer;
            } else {
              console.info('The customer does not exist within this venue, this 404 is not an error');
              // Set subscribed flag to true by default since it's this customer's first visit
              customerItem.subscribed = true;
            }
            resolve();
          });
        }).then(() => {

          updatingCustomer = true;

          /**
           * Due to bug in md-autocomplete, where ng-if removal causes md-scroll-mask to not get cleaned up properly
           * (REF: https://github.com/angular/material/issues/9318) we temporarily use ng-hide instead just before ng-if.
           * This allows it to clean up properly, as ng-hide does not have the same bug.
           */
          vm.inlineRemovalInProgress = true;

          setTimeout(function () {
            // an existing customer was selected
            vm.customer.customerType = CustomerTypes.existing;

            // add the custome object
            vm.customer = ObjectCopyService.angularSafeCopy(customerItem);
            vm.originCustomer = ObjectCopyService.angularSafeCopy(customerItem);

            vm.customer.updatingCustomer = true;
            // detect phone validation of existing customer
            checkIsPhoneNumberType();

            vm.phoneWithoutPrefix = vm.customer.phone;
            vm.phoneInitial = vm.customer.phone;
            vm.handleOriginalCustomerChange && vm.handleOriginalCustomerChange(ObjectCopyService.angularSafeCopy(customerItem));
            // allow autocomplete again
            setTimeout(function () {
              updatingCustomer = false;
              vm.inlineRemovalInProgress = false;
              vm.customer.edited = false; // if the form is edited again.
            }, 1000);
          }, 0);
        });

      } else if (customerItem.type === 'new' || customerItem.type === 'inline') {
        // console.log('CustomerSelected new/inline', customerItem);
        // create a customer
        vm.customer = {
          customerType: customerItem.type,
          // Following GDPR: NBI-6152
          subscribed: vm.venue.defaultEmailSubscribedForDiary,
        };
        vm.searchText = lastQuery;
      }
    }
  }

  function phoneChange(phoneNumber) {
    if (!vm.isPhoneNumberType) {
      var formattedPhone = PhoneNumberService.normalizePhoneNumber(phoneNumber, phoneNumberTypes.INTERNATIONAL, vm.venue);
      if (formattedPhone) {
        vm.customer.phone = formattedPhone;
        vm.isPhoneValid = true;
      } else {
        vm.isPhoneValid = false;
      }
    }
  }

  function handlePhoneChange(phone) {
    vm.customer.phone = phone;
    vm.isPhoneDirty = true;
  }

  function setPhoneWithoutPrefix(phone) {
    vm.phoneWithoutPrefix = phone;
  }

  function setPhoneValid(flag) {
    vm.isPhoneValid = !flag
  }

  function setPhoneTouched(flag) {
    vm.isPhoneTouched = flag
  }

  function setBookedByErrors(errs) {
    vm.bookedByErrors = errs
  }

  function validateCustomer() {
    vm.customerValid = false;
    if (!$scope.customerForm) {
      return;
    }
    const emailValid = emailValidation();
    const validationError = getValidationError();
    const customerValidation = (emailValid.valid && !validationError) && CustomerValidationService.validateCustomer(vm.customer, vm.originCustomer, vm.emailRequired, vm.ignorePhoneValidation, vm.isEwayAndNotWalkinBooking);
    vm.customer.edited = customerValidation.isEdited;

    const isBookedByValid = CustomerValidationService.checkBookedByValid(vm.bookedByErrors, vm.isBookedBy, vm.bookedByCustomerDetails, vm.isEwayAndNotWalkinBooking);
    vm.customerSectionValid = customerValidation.isValid;
    vm.bookedBySectionValid = isBookedByValid;
    vm.customerValid = (customerValidation.isValid && isBookedByValid) || false;

    if (customerValidation.isBirthdayValid !== null) {
      if ($scope.customerForm.birthdayDate) {
        $scope.customerForm.birthdayDate.$setValidity("validDate", customerValidation.isBirthdayValid);
      }
      if ($scope.customerForm.birthdayMonth) {
        $scope.customerForm.birthdayMonth.$setValidity("validDate", customerValidation.isBirthdayValid);
      }
      if ($scope.customerForm.birthdayYear) {
        $scope.customerForm.birthdayYear.$setValidity("validDate", customerValidation.isBirthdayValid);
      }
    }
  }

  function newCustomer() {
    vm.customer.customerType = CustomerTypes.new;
  }

  function clearEdit() {
    delete vm.customer._id;
    delete vm.customer._rev;
    // Hide the beverage button
    vm.beverageList = [];
  }

  function emailValidation() {
    const tempCustomer = ObjectCopyService.angularSafeCopy(vm.customer);
    return CustomerValidationService.emailValidation(tempCustomer, vm.isNoPayment, vm.isRecurringBooking, vm.isEditCustomer, vm.bookingType === BookingType.StandbyList, vm.sblEmailRequired, vm.isBookedBy, vm.isPrivateFunEvent);
  }

  function switchToRepeatBookingTab() {
    vm.openRepeatBookingTab = true;
  }

  function getValidationError() {
    return CustomerValidationService.getValidationError(
      vm.phoneNumberTooShort[SEARCH_FIELDS.PHONE], vm.customer.phone, vm.customer.email, vm.isPhoneTouched,
      vm.isPhoneValid, vm.displayErrors, vm.isNoPayment, vm.isRecurringBooking, vm.isEditCustomer, vm.isPhoneDirty,
      vm.bookingType === BookingType.StandbyList, vm.sblSmsRequired, vm.isBookedBy, vm.isPrivateFunEvent
    );
  }

  // for new customer search ---- start ----
  const debounceSearch = debounce(searchDebounce, 1000);

  /***
   * set customer search object
   * @param type search field
   * @param value search value
   * @param phoneWithoutPrefix phone without prefix
   */
  function setCustomerSearch(type, value, phoneWithoutPrefix = null) {
    vm.searchResultStatus = 0; //init status
    vm.customerSearchObj = {
      ...vm.customerSearchObj,
      [type]: value
    };

    vm.customer = CustomerSearchService.modifyCustomerObjectForSearch(vm.customerSearchObj, vm.customer)

    // if user edit input value, empty last search result, cancel last debounce
    setCustomers([]);
    debounceSearch.cancel();
    // search validation ask for phone without prefix
    const searchValue = type === SEARCH_FIELDS.PHONE ? phoneWithoutPrefix : value;
    // value empty for user clear input, then show search result for other input value
    if (!value) {
      CustomerSearchService.searchCustomer(vm.customerSearchObj, vm.venue).then((res) => {
        if (res.length === 0 && Object.values(vm.customerSearchObj).filter(i => !!i).length > 0) {
          vm.searchResultStatus = 2; //no result, show warning message
        } else {
          vm.searchResultStatus = 0; //init status
        }
        setCustomers(res);


      });
    } else {
      // if user didn't pass validation, don't search
      if (!checkSearchCondition(type, value)) {
        return;
      }
      // this if statement is for pass old customer form validation
      if (type === SEARCH_FIELDS.PHONE) {
        vm.phoneWithoutPrefix = phoneWithoutPrefix;
      }
      debounceSearch(searchValue, type, vm.customerSearchObj);
    }

  }
  function searchDebounce(value, type, customerSearchObj) {
    // vm.searchResultStatus = 1; // loading search, we may need it in future
    search(value, type, null, customerSearchObj).then((res) => {
      // due to search function has return null and return [] two cases
      if (res) {
        if (res.length === 0) {
          vm.searchResultStatus = 2; //no result, show warning message
        } else {
          vm.searchResultStatus = 0; //init status
        }
        setCustomers(res);
      } else {
        setCustomers([]);
      }
    });
  }

  /***
   * for new customer form which no build-in limitation
   * @param type
   * @param value
   * @returns {boolean} - true means valid, false means invalid
   */
  function checkSearchCondition(type, value) {
    switch (type) {
      case SEARCH_FIELDS.FIRST_NAME:
      case SEARCH_FIELDS.LAST_NAME:
        return value && value.length >= 3;
      default:
        return true;
    }
  }

  function setCustomers(customers) {
    if (customers) {
      vm.customers = customers;
    }
  }
  // for new customer search ---- end ----

  /***
   * this setView also include code about what need to be done when switch view
   * so carefully call this one, if only want to change view, use vm.viewType = xxx
   * @param view {string} - view type
   */
  function setView(view, cleanBookBy = true) {
    if (vm.viewType === vm.customerViewType.SEARCH_CUSTOMER_VIEW && view === vm.customerViewType.NEW_CUSTOMER_VIEW) { //from search page to new page
      vm.expandedCustomer = true;
      if (vm.customerSearchObj.phone) {
        vm.phoneInitial = vm.customerSearchObj.phone;
      }
      vm.customer = {
        ...vm.customer,
        ...vm.customerSearchObj,
      };
      // for show data error without onChange
      if (vm.customerSearchObj.phone) {
        if (CustomerGeneratorService.isPhoneNumberTooShortForSearch(vm.customerSearchObj.phone)) {
          vm.phoneNumberTooShort[SEARCH_FIELDS.PHONE] = true;
        } else {
          const res = PhoneNumberService.parsePhoneNumber(vm.customer.phone);
          vm.isPhoneValid = res.isValid();
        }
        vm.isPhoneTouched = true;
      }
      if (vm.customerSearchObj.email) {
        if (!!$scope.customerForm) {
          $scope.customerForm.email.$dirty = true;
        }
      }
      // for hidden duplication error
      vm.isDuplicatedCustomer = false;
    } else if (vm.viewType === vm.customerViewType.NEW_CUSTOMER_VIEW && view === vm.customerViewType.SEARCH_CUSTOMER_VIEW) { //from new page to search page
      // to trigger refresh
      vm.customerSearchObj = {
        ...vm.customer,
      };
      CustomerSearchService.searchCustomer(vm.customerSearchObj, vm.venue).then((res) => {
        setCustomers(res);
      });
    } else if (vm.viewType === vm.customerViewType.DISPLAY_EXISTING_CUSTOMER_VIEW && view === vm.customerViewType.SEARCH_CUSTOMER_VIEW) { //from display page to search page
      vm.customerSearchObj = {
        // clean customer data, only left search value for search page
        firstName: vm.customer.firstName || '',
        lastName: vm.customer.lastName || '',
        email: vm.customer.email || '',
        phone: vm.customer.phone || '',
      };
      CustomerSearchService.searchCustomer(vm.customerSearchObj, vm.venue).then((res) => {
        setCustomers(res);
      });
      vm.customer = { subscribed: true }; //clear customer data as Teryn's request in NBI 5521
    }
    vm.viewType = view;
    // clean bookedBy data when switch view
    if (cleanBookBy) {
      vm.cleanBookedByData();
      vm.isBookedBy = false;
    }
  }

  function setErrors(inputKey, error) {
    vm.errors = {
      ...vm.errors,
      [inputKey]: error
    }
  }
  // this function for new customer form that use old component but no search function
  function searchInNewCustomerForm() {
    return [];
  }
  function toggleBookedBy(checked) {
    vm.isBookedBy = checked;
    vm.disableEmailSmsNotification = checked
    if (vm.isBookedBy) {
      vm.expandBookedBy = true; // expend bookedBy section when bookedBy toggle on
      vm.expandedCustomer = false; // expend customer section when bookedBy toggle on
    } else {
      vm.cleanBookedByData(); // clean bookedBy data when bookedBy toggle off
      // vm.isBookedBy = false;
    }
    vm.triggerBookedByValidation = 0; // clean bookedBy validation when bookedBy toggle off
    validateCustomer();
  }

  function toggleBookedByNoEvent(checked) {
    vm.isBookedBy = checked;
    if (!vm.isBookedBy) {
      vm.cleanBookedByData(); // clean bookedBy data when bookedBy toggle off
    }
    vm.triggerBookedByValidation = 0;
    validateCustomer();
  }
  /***
   * this function for select customer from new search page, the info will pass to display page
   * @param customer {Object} customer info
   * @returns {Promise<void>}
   */
  async function handleDisplayCustomer(customer) {
    const updatedCustomer = await addVenueLevelInfoToCustomer(customer);
    vm.originCustomer = ObjectCopyService.angularSafeCopy(updatedCustomer);
    vm.handleNewCustomerSelected(updatedCustomer, false);
    vm.setView(vm.customerViewType.DISPLAY_EXISTING_CUSTOMER_VIEW);
    // start ---- make it pass data validation, in case user input invalid data then choose from search result
    vm.phoneNumberTooShort[SEARCH_FIELDS.PHONE] = false;
    vm.isPhoneValid = true;
    // end ---- make it pass data validation, in case user input invalid data then choose from search result
  }
  /***
   * this function for save customer in edit page, and this customer from new search page. the info will pass to display page
   * @param customer {Object} customer info
   */
  function handleSaveEditCustomer(customer) {
    vm.originCustomer = ObjectCopyService.angularSafeCopy(customer);
    vm.handleNewCustomerSelected(customer, false);
    vm.setView(vm.customerViewType.DISPLAY_EXISTING_CUSTOMER_VIEW);
    // start ---- make it pass data validation, in case user input invalid data then choose from search result
    vm.phoneNumberTooShort[SEARCH_FIELDS.PHONE] = false;
    vm.isPhoneValid = true;
    // end ---- make it pass data validation, in case user input invalid data then choose from search result
  }

  /***
   * this function for edit customer from new search page
   * @param customer {Object} customer info
   * @returns {Promise<void>}
   */
  async function handleEditCustomer(customer) {
    const updatedCustomer = await addVenueLevelInfoToCustomer(customer);
    vm.setHiddenDialog(true);
    setTimeout(() => { // needs delay so onEditBookingClosed has time

      ViewActionsService.onEditCustomerOpened();
      updateOfflineStatus();
      $mdDialog.show({
        skipHide: true,
        controller: 'EditCustomer',
        controllerAs: 'editCustomer',
        templateUrl: 'app/customers/edit/editCustomer.html',
        locals: {
          customer: updatedCustomer,
          isOffline: vm.isOffline,
          handleNewCustomerSelected: handleSaveEditCustomer,
        },
        clickOutsideToClose: true,

        onComplete: function ($scope) {
          $scope.editCustomer.showComplete = true;
        },

        onRemoving: function () {
          ViewActionsService.onEditCustomerClosed(false);
          vm.setHiddenDialog(false);
        }

      });
    }, 500);
  }
  /***
   * after select customer from search page, this function will be called to add more info to customer
   * all code from customerSelected() in same page. but simple it
   * @param customerItem customer from search page
   * @returns {Promise<*>}
   */
  async function addVenueLevelInfoToCustomer(customerItem) {
    if (customerItem._id) {
      const accountCustomer = await CustomerLookupService.getAccountCustomerById(customerItem._id);
      const venueCustomer = toVenueCustomer(accountCustomer, vm.venue.id);
      if (venueCustomer) {
        console.log('Replace customer with its more detailed venue entity');
        customerItem = venueCustomer;
      } else {
        console.info('The customer does not exist within this venue, this 404 is not an error');
        // Set subscribed flag to true by default since it's this customer's first visit
        customerItem.subscribed = true;
      }
      customerItem.updatingCustomer = true;
    }
    return customerItem;
  }
  function updateOfflineStatus() {
    // if connection has already been lost, status isn't changed
    if (AdminService.getVenue().isOnlineCustomersEnabled && !NetworkConnectionService.isOnline()) {
      vm.isOffline = true;
    }
  }
  function handleShowMore() {
    vm.showMore = !vm.showMore;
  }
  function toggleEmailSmsNotification(checked) {
    vm.disableEmailSmsNotification = checked
  }
}
